import './accordion-main.scss';

import { AccordionGroup } from '@sola/ark-core/molecules/accordion-group/accordion-group.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { getHeaderDisplayLevel } from '@sola/utils/assembly.ts';

import { FeatureBase } from '../../../molecules/feature-base/feature-base.tsx';
import { getPlaceholderItems } from '../../../utils/storybook.tsx';
import { getBaseSizeProps } from '../../../utils/text-utils.tsx';

export const AccordionMain: React.FC<FlexibleContentProps> = ({
  seoLevel = 2,
  items,
  alt,
  media: _media,
  quotation: _quotation,
  ...props
}) => {
  const accordionItems =
    !items || items.length < 2 ? getPlaceholderItems(items, 2) : items;

  const hasHeaderContent = !!props.title || !!props.body;
  const headerDisplayLevel = getHeaderDisplayLevel(seoLevel);

  return (
    <section className="Accordion component">
      <div
        className={cn('container w-full flex flex-col gap-comfy-xl', {
          'Accordion--alt @md:flex-row': alt,
          'items-center @md:gap-roomy-xs  @lg:gap-roomy-sm': !alt,
        })}
      >
        <div
          className={cn('Accordion__content w-full', {
            'mx-auto md:max-w-md': !alt,
          })}
        >
          <FeatureBase
            {...props}
            {...getBaseSizeProps(headerDisplayLevel)}
            seoLevel={seoLevel}
            variant={alt ? 'standard' : 'centered'}
            inline
          />
        </div>

        <div className={cn('w-full max-w-md', { 'mx-auto': alt })}>
          <AccordionGroup
            items={accordionItems.map(
              ({
                title,
                subtitle: _subtitle,
                quotation: _quotationitem,
                primaryCTA: _primaryCTA,
                secondaryCTA: _secondaryCTA,
                tertiaryCTA: _tertiaryCTA,
                media: _mediaItem,
                icon: _icon,
                ...item
              }) => ({
                header: title || '',
                seoLevel: hasHeaderContent ? seoLevel + 1 : seoLevel,
                children: (
                  <FeatureBase
                    {...item}
                    variant="standard"
                    bodySize="sm"
                    buttonSize="sm"
                    inline
                  />
                ),
              }),
            )}
          />
        </div>
      </div>
    </section>
  );
};
